export * from './incidents-table/incidents-table.component';
export * from './incidents-table-desktop-filters/incidents-table-desktop-filters.component';
export { IncidentsV2TableComponent } from './incidents-v2-table/incidents-v2-table.component';
export { IncidentsV2TableDesktopFiltersComponent } from './incidents-v2-table-desktop-filters/incidents-v2-table-desktop-filters.component';
